import { BaseExtension } from "../extensions/baseExtension.js";
//#region src/instrumentations/base.ts
var BaseInstrumentation = class extends BaseExtension {
	constructor(..._args) {
		super(..._args);
		this.api = {};
		this.transports = {};
	}
};
//#endregion
export { BaseInstrumentation };

//# sourceMappingURL=base.js.map